import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import AuthApi from '../../Services/Authapi';
import swal from 'sweetalert';
import AuthCheckComponent from '../../Layouts/Token';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';
import '../Leaves/Leave.css';


const inivalue = {
    department: "",
};

const Departmenteadd = (props) => {
    const classes = props;
    const [qulifi, setQulifi] = useState(inivalue);
    const [formErrors, setFormErrors] = useState({});
    const [submitLoading, setSubmitLoading] = useState(false);
    const history = useHistory();

    useEffect(() => {
        if (props && props.authToken === false) {
            // history.push('/login');
        }
    }, [props, history]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setQulifi({ ...qulifi, [name]: value });
        if (formErrors[name]) {
            const stringValue = typeof value === "string" ? value.trim() : value;
            if (stringValue !== "") {
                setFormErrors((prev) => {
                    const next = { ...prev };
                    delete next[name];
                    return next;
                });
            }
        }
    };

    const validate = (values) => {
        let errors = {};
        if (!values.department) {
            errors.department = "Cannot be blank";
        }
        return errors;
    };

    const createDepartment = async () => {
        setSubmitLoading(true);
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            width: "10%",
            content: createSwalLoaderNode()
        });
        try {
            let create = await AuthApi.Departmentcreate1(qulifi);
            swal.close();
            if (create && create.status === true) {
                swal("Success", "Department added successfully", "success").then(() => {
                    history.push('/Departmente');
                });
            } else {
                swal({
                    title: "OOPS!",
                    icon: "error",
                    text: create && create.message ? create.message : "Something went wrong, Please try later!"
                });
            }
        } catch (error) {
            swal.close();
            console.error("Error updating qulification:", error);
            swal("Error", "An unexpected error occurred", "error");
        } finally {
            setSubmitLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitLoading) {
            return;
        }
        const errors = validate(qulifi);
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }
        await createDepartment();
    };

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                component={
                    <div>
                        <div className="holiday-breadcrumb-card">
                                <Breadcrumb
                                    {...props}
                                    primaryPageName="Department"
                                    primaryPageLink="/Departmente"
                                    isSecondaryPage={true}
                                    secondaryPageName="Add Department" />
                        </div>

                        <div className="holiday-form-card">
                                        <Typography
                                            variant="h2"
                                            className="common-form-page-title holiday-form-title"
                                        >
                                            Add Department
                                        </Typography>
                                        <form className={`${classes.form} common-form-fields`} onSubmit={handleSubmit}>
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={6}>
                                                    <TextField
                                                        fullWidth
                                                        id="department"
                                                        name="department"
                                                        label="Department"
                                                        variant="outlined"
                                                        error={formErrors.department && true}
                                                        value={qulifi.department}
                                                        onChange={handleChange}
                                                        className={formErrors.department && "input-error"}
                                                    />
                                                    {formErrors.department && (
                                                        <span className="error">{formErrors.department}</span>
                                                    )}
                                                </Grid>

                                            </Grid>
                                            <div className="holiday-form-actions">
                                                <Button type="submit" className="btn-success" style={{ textTransform: 'none' }} variant="contained" color="primary" disabled={submitLoading}>
                                                    {submitLoading ? <><CircularProgress size={18} style={{ marginRight: 8, color: 'inherit' }} /> Saving...</> : 'Save'}
                                                </Button>
                                                <Button type="button" className="btn-cancel" style={{ textTransform: 'none' }} disabled={submitLoading} onClick={(e) => { e.preventDefault(); history.push('/Departmente'); }}>Cancel</Button>
                                            </div>
                                        </form>
                        </div>
                    </div>
                } />
            <Footer />
        </div>
    );
};

export default Departmenteadd;
